<template>
 <Hero/>
</template>



<script setup>
import Hero from "@/components/home/Hero.vue";
</script>
